import React from 'react';
import './ProblemLocation.css';

export default function SubmitFormMessage({ formInfo, closeModal }) {
  const { formSubmitStatus } = formInfo;
  return (
    <div className="problem-location-container">
      {formSubmitStatus
        ? 'Uspješno ste unijeli kvar.'
        : 'Trenutno nije moguće izvršiti unos kvara.'}
      <button type="submit" className="pl-close-button" onClick={closeModal}>
        Zatvori
      </button>
    </div>
  );
}
